import {forwardRef, useImperativeHandle, useState} from "react";
import {Button, Modal, Space} from "antd";
import {useTranslation} from "react-i18next";
import {imgPathPerfix} from "../../utils";
import "./DialogNewProject.css"
import {IconClose} from "@/Icon";

const DialogNewProject = forwardRef((props:{onItemClicked:any},ref)=>{
    useImperativeHandle(ref,()=>({
        showNewProjectDialog:showNewProjectDialog
    }));
    const {t} = useTranslation();
    const [isShowNewPeojectDialog,setIsShowNewPeojectDialog] = useState(false);

    const showNewProjectDialog = ()=>{
        setIsShowNewPeojectDialog(true);
    }

    const onItemClickEvent = (szType:string)=>{
        setIsShowNewPeojectDialog(false);
        props.onItemClicked(szType);
    }

   return(
       <Modal width={'640px'} destroyOnClose={true} visible={isShowNewPeojectDialog}
              centered={true}
              footer={''}
              closable={true}
              closeIcon={<IconClose/>}
              onCancel={()=>setIsShowNewPeojectDialog(false)}>
           <span className='title-create-project'>{t("Create a new project")}</span>
           <div className='div-container'>
               <Button className='button-item' type={"text"} onClick={()=>{onItemClickEvent('blank')}}>
                   <img className='img-small' src={imgPathPerfix()+"start_from_blank.png"}/>
                   <span>{t("Start from blank")}</span>
               </Button>

               <Button className='button-item' type={"text"} style={{margin:'0 16px'}} onClick={()=>{onItemClickEvent('template')}}>
                   <img className='img-small' src={imgPathPerfix()+"start_from_templates.png"}/>
                   <span>{t("Start from Templates")}</span>
               </Button>

               <Button className='button-item' type={"text"} onClick={()=>{onItemClickEvent('import')}}>
                   <img className='img-small' src={imgPathPerfix()+"start_from_import.png"}/>
                   <span>{t("Import canvas project")}</span>
               </Button>
           </div>
       </Modal>
   )
});

export default DialogNewProject;